import React from 'react';

function AvailableColors(props) {
  return (
    <section className="available-colors">
      <h2>Izvēlies {props.colorCount} krāsas:</h2>
      <div className="available-colors__color-list">
        {props.children}
      </div>
      <p className="available-colors__notice">* Vienas krāsas svars komplektā ir 40 grami.<br />* Jūsu izvēlētās krāsas tiks safasētas paciņās.</p>
    </section>
  );
}

export default AvailableColors;



// WEBPACK FOOTER //
// ./src/components/availableColors.js